"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var bodyFixedStore_1 = require("mobile/stores/bodyFixedStore");
var styles = require("./index.scss");
var Dialog = (function (_super) {
    __extends(Dialog, _super);
    function Dialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            show: _this.props.show
        };
        _this.toggleShow = function (show) {
            if (typeof show === "boolean") {
                if (show !== _this.state.show) {
                    _this.setState({ show: show });
                }
            }
            else {
                _this.setState(function (prevState) { return ({
                    show: !prevState.show
                }); });
            }
        };
        _this.show = function () { return _this.toggleShow(true); };
        _this.hide = function () { return _this.toggleShow(false); };
        _this.handleRootElmClick = function (e) {
            var _a = _this.props, onClick = _a.onClick, show = _a.show, isClickBGHide = _a.isClickBGHide;
            if (typeof show === "undefined" &&
                isClickBGHide &&
                _this.state.show &&
                e.target === _this.rootElm) {
                _this.toggleShow(false);
            }
            if (typeof onClick !== "undefined" && e.target === _this.rootElm) {
                onClick(e);
            }
        };
        _this.getContentAttributes = function () {
            var _a = _this.props.contentAttributes, contentAttributes = _a === void 0 ? {} : _a;
            var children = contentAttributes.children, attributes = __rest(contentAttributes, ["children"]);
            return attributes;
        };
        return _this;
    }
    Dialog.prototype.componentWillReceiveProps = function (nextProps) {
        var show = nextProps.show;
        if (show !== this.props.show && show !== this.state.show) {
            this.setState({ show: show });
        }
    };
    Dialog.prototype.componentWillUpdate = function (nextProps, nextState) {
        if (nextProps.isAutoFixedBody && nextState.show !== this.state.show) {
            if (nextState.show) {
                bodyFixedStore_1.getStore().stopScroll();
            }
            else {
                bodyFixedStore_1.getStore().revertScroll();
            }
        }
    };
    Dialog.prototype.componentWillUnmount = function () {
        var isAutoFixedBody = this.props.isAutoFixedBody;
        var show = this.state.show;
        if (isAutoFixedBody && show) {
            bodyFixedStore_1.getStore().revertScroll();
        }
    };
    Dialog.prototype.render = function () {
        var _this = this;
        var _a = this.props, onClickCB = _a.onClickCB, className = _a.className, contentAttributes = _a.contentAttributes, show = _a.show, isAutoFixedBody = _a.isAutoFixedBody, otherAttributes = __rest(_a, ["onClickCB", "className", "contentAttributes", "show", "isAutoFixedBody"]);
        var children = otherAttributes.children, isClickBGHide = otherAttributes.isClickBGHide, attributes = __rest(otherAttributes, ["children", "isClickBGHide"]);
        return (React.createElement("div", __assign({ className: styles.c + " " + className + " " + styles[this.state.show ? "cShow" : "cNotShow"] }, attributes, { ref: function (rootElm) { return (_this.rootElm = rootElm); }, onClick: this.state.show ? this.handleRootElmClick : void 0 }),
            React.createElement("div", __assign({ ref: function (contentElm) { return (_this.contentElm = contentElm); }, className: (contentAttributes ? contentAttributes.className : "") + " " + styles.cDialog + " " + styles[this.state.show ? "cDialogShow" : "cDialogNotShow"] }, this.getContentAttributes(), { onClick: function () {
                    onClickCB(_this);
                } }), this.props.children)));
    };
    Dialog.defaultProps = {
        isAutoFixedBody: false,
        className: "",
        onClickCB: function () { },
        onClick: function () { }
    };
    return Dialog;
}(React.Component));
exports.default = Dialog;
